export enum ItemType {
  Modification = 'modification',
  Service = 'service',
  Goods = 'goods',
  Assets = 'assets',
  Transportation = 'transportation',
  Transfers = 'transfers',
}
